/**
 * @generated SignedSource<<6fea4492af5127de9abab7d52a1676d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditInvitationEmailModal_tenant$data = {
  readonly emailTemplates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      } | null;
    } | null>;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SaveTemplateModal_tenant" | "SelectTemplateModal_tenant">;
  readonly " $fragmentType": "EditInvitationEmailModal_tenant";
};
export type EditInvitationEmailModal_tenant$key = {
  readonly " $data"?: EditInvitationEmailModal_tenant$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditInvitationEmailModal_tenant">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditInvitationEmailModal_tenant",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmailTemplateConnection",
      "kind": "LinkedField",
      "name": "emailTemplates",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmailTemplateEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EmailTemplateNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SelectTemplateModal_tenant"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SaveTemplateModal_tenant"
    }
  ],
  "type": "TenantNode",
  "abstractKey": null
};

(node as any).hash = "9ef89d9885176f0ad48632d896f82aaa";

export default node;
